import React, { useEffect, useState, useContext } from "react";
import creditService from '../../services/api/genai-credits-service';
import { useHistory, useLocation } from "react-router-dom";
import UserContext from "../../UserContext";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
} from "reactstrap";


const Edit = (props) => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const creditId = queryParams.get("id");
  const [creditDetails, setCreditDetails] = useState(null);

  const [showLoader, setShowLoader] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [dailyQuotaState, setDailyQuotaState] = useState("");
  const [dailyQuotaError, setDailyQuotaError] = useState("");

  useEffect(() => {
    (async () => {
      if (creditId) {
        setShowLoader(true);
        const creditDetails = await creditService.getCreditById(creditId);
        if (creditDetails && creditDetails.status && creditDetails.data) {
          setCreditDetails(creditDetails.data);
        }
        setShowLoader(false);
      }
    })();
  }, [creditId]);

  const changeDailyQuota = (value) => {
    setCreditDetails({ ...creditDetails, daily_quota: value });
    setDailyQuotaState("");
    setDailyQuotaError("");
  }

  const handleSubmit = function (e) { validateForm(); e.preventDefault() }

  const validateFields = () => {
    let validations = true;
    if (!creditDetails.daily_quota) {
      setDailyQuotaState("has-danger");
      setDailyQuotaError("Please enter the daily quota limit.");
      validations = false;
    } else if (isNaN(creditDetails.daily_quota) || creditDetails.daily_quota <= 0) {
      setDailyQuotaState("has-danger");
      setDailyQuotaError("Please enter a valid positive number for the daily quota.");
      validations = false;
    }
    return validations;
  }

  const validateForm = async () => {
    let validated = validateFields();
    if (!validated) {
      return;
    }
    setShowLoader(true);    
    setShowSaveButton(false);
    let updateQuota = await creditService.updateDailyQuota({ project_id: creditDetails.project_id._id, daily_quota: creditDetails.daily_quota });
   
    if (updateQuota.status) {
      setTimeout(() => {
        setShowLoader(false)
        setAlert({ show: true, type: 'success', message: 'Daily quota limit updated successfully' });
      }, 1000);

      setTimeout(() => {
        setAlert({ show: false, type: '', message: '' });
      }, 3000);

      setTimeout(() => {
        history.goBack();
      }, 2000);

    } else {
      setTimeout(() => {
        setShowLoader(false)
        setShowSaveButton(true)
        setAlert({ show: true, type: 'danger', message: updateQuota?.error?.message || 'Failed to update daily quota limit. Please try again.' });
      }, 1000);

      setTimeout(() => {
        setShowLoader(false)
        setShowSaveButton(true)
        setAlert({ show: false, type: '', message: '' });
      }, 3000);
    }
  }

  const redirectUrl = (event) => {
    event.preventDefault();
    history.goBack();
  }

  return (
    <div className="content">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <Card className="card-signup text-center">
              <CardHeader>
                <CardTitle tag="h4">Edit Daily Quota Limit</CardTitle>
              </CardHeader>
              <CardBody>
                <Form className="form-horizontol" action="" id="editQuota" method="POST" onSubmit={handleSubmit}>
                  <Row>
                    <Label className="bold" sm="2">Project Name</Label>
                    <Col sm="7">
                      <FormGroup>
                        <Input
                          type="text"
                          id="projectName"                          
                          value={(creditDetails && creditDetails.project_id) ? creditDetails.project_id.name : ''}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Label className="bold" sm="2">Publisher</Label>
                    <Col sm="7">
                      <FormGroup>
                        <Input
                          type="text"
                          id="createdBy"                          
                          value={creditDetails ? creditDetails.created_by : ''}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>


                  <Row>
                    <Label className="bold" sm="2">Assigned By</Label>
                    <Col sm="7">
                      <FormGroup>
                        <Input
                          type="text"
                          id="createdBy"                          
                          value={creditDetails ? creditDetails.created_by : ''}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Label className="bold" sm="2">Total Credits</Label>
                    <Col sm="7">
                      <FormGroup>
                        <Input
                          type="number"
                          id="totalQuota"
                          value={creditDetails?.total_quota}
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Label className="bold" sm="2">Daily Quota Limit <span className="text-danger"> * </span></Label>
                    <Col sm="7">                      
                      <FormGroup className={dailyQuotaState}>
                      <Input
                        type="number"
                        id="daily_quota"
                        min='1'
                        value={creditDetails?.daily_quota}
                        onChange={(e) => changeDailyQuota(e.target.value)}
                        required
                      />
                      {dailyQuotaState === "has-danger" ? (
                        <label className="error">
                          {dailyQuotaError}
                        </label>
                      ) : null}
                         
                      </FormGroup>
                    </Col>
                  </Row>

                  {showLoader ? (
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  ) : (
                    <>
                      {showSaveButton && (
                        <div>
                          <Button
                            className="btn-round"
                            color="info"
                            type="button"
                            onClick={validateForm}
                          >
                            Update
                          </Button>

                          <Button
                            className="btn-round"
                            color="warning"
                            type="button"
                            onClick={redirectUrl}
                          >
                            Cancel
                          </Button>
                        </div>
                      )}

                      {alert.show && (
                        <Alert color={alert.type}>
                          {alert.message}
                        </Alert>
                      )}
                    </>
                  )}


                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
        }}
      />
    </div>
  );

}

export default Edit;